import { getEnv } from '@ctct/ctct-helpers';

import { BaseApiClient } from '../BaseApiClient';

class AccessEngineApi {
  private baseApiClient: BaseApiClient;

  constructor() {
    const baseUrl = `https://app${getEnv()}constantcontact.com/v2/access`;

    this.baseApiClient = new BaseApiClient(baseUrl);
  }

  public deleteCache() {
    return this.baseApiClient.delete('/cache');
  }
}

export const accessEngineApi = new AccessEngineApi();
